import { useState } from "react";
import { getRankBadgeUrl } from "../../utils/rankBadges";

export const RankBadge = ({
  rankKey,
  rankLabel,
  size = 64,
  className = "",
}: {
  rankKey?: string;
  rankLabel?: string;
  size?: number;
  className?: string;
}) => {
  const [hidden, setHidden] = useState(false);
  const badgeUrl = getRankBadgeUrl(String(rankKey || ""));
  const alt = String(rankLabel || "Rank badge").trim() || "Rank badge";

  if (!badgeUrl || hidden) return null;

  return (
    <img
      src={badgeUrl}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      onError={() => setHidden(true)}
      className={`shrink-0 object-contain ${className}`.trim()}
    />
  );
};

export default RankBadge;
